import { DefaultState } from '@portal/portal-core';
import * as Types from '../types';

interface CustomFieldsResponse {
  requestType: string;
  [key: string]: unknown;
}

export interface CustomFieldsState {
  response: CustomFieldsResponse | undefined;
}

export const initialState: CustomFieldsState = {
  response: undefined,
};

export const CustomFields = (
  state: CustomFieldsState = initialState,
  action: { type: string; payload?: unknown },
): CustomFieldsState => {
  const { payload } = action;
  switch (action.type) {
    case Types.CREATE_CUSTOM_FIELD_RESULT:
      return {
        ...state,
        response: { ...(payload as object), requestType: Types.CREATE_CUSTOM_FIELD },
      };
    case Types.UPDATE_CUSTOM_FIELD_RESULT:
      return {
        ...state,
        response: { ...(payload as object), requestType: Types.UPDATE_CUSTOM_FIELD },
      };
    case Types.UPDATE_CUSTOM_FIELD_ORDER_RESULT:
      return {
        ...state,
        response: { ...(payload as object), requestType: Types.UPDATE_CUSTOM_FIELD_ORDER },
      };
    case Types.UPDATE_USER_CUSTOM_FIELD_VALUES_RESULT:
      return {
        ...state,
        response: { ...(payload as object), requestType: Types.UPDATE_CUSTOM_FIELD_VALUES },
      };
    case Types.UPDATE_CUSTOM_FIELD_VALUES_WITH_INVITE_RESULT:
      return {
        ...state,
        response: {
          ...(payload as object),
          requestType: Types.UPDATE_CUSTOM_FIELD_VALUES_WITH_INVITE,
        },
      };
    case Types.UPDATE_ADMIN_CUSTOM_FIELD_VALUES_RESULT:
      return {
        ...state,
        response: { ...(payload as object), requestType: Types.UPDATE_ADMIN_CUSTOM_FIELD_VALUES },
      };
    case Types.CLEAR_CUSTOM_FIELD_RESULTS:
      return {
        ...state,
        initialState,
      } as CustomFieldsState;
    case DefaultState.DEFAULT_STATE:
      return initialState;
    default:
      return state;
  }
};
